import React, { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from "../components/Header"
import Footer from "../components/Footer"
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import { createStore } from "../store/state"
import { setAuthToken } from '../controller/api';

export default function Layout() {
    const [isActive, setIsActive] = useState(false);

    const location = useLocation()
    const { user } = createStore((state) => state)

    const menuStyle = isActive ? "menu open" : "menu";
    setAuthToken(user?.token || "")

    return (
        <>
            <Header />
            <nav>
                <div className='res-menu'>
                    <span>Menu</span>
                    <div
                        className="hamburger"
                        onClick={() => setIsActive((action) => !action)}
                    >
                        {isActive ? <IoClose /> : <IoMenu />}
                    </div>
                </div>
                <ul className={menuStyle} onClick={() => setIsActive((action) => !action)}>
                    <Navigation />
                </ul>
            </nav>
            {location.pathname === '/overview' && <Hero />}
            <Outlet />
            <Footer />
        </>
    )
}
